module.exports = __webpack_public_path__ + "img/natalia_katcharava-min.bd28ca41.jpg";